import React, { useState } from "react";
import All_Buyer from "./All_Buyer/All_Buyer";
import All_seller from "./All_Seller/All_seller";

function Product_Owner_details() {
  const [activeTab, setActiveTab] = useState("All_Buyer");

  return (
    <>
      <div>
        <div className="flex flex-col">
          {/* Tab Navigation */}
          <div className="flex items-center justify-between text-lg font-semibold gap-4 mt-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setActiveTab("All_Buyer")}
                className={
                  activeTab === "All_Buyer"
                    ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                    : "text-gray-500 hover:text-[#FF0000]"
                }
              >
                All Buyer
              </button>
              <button
                onClick={() => setActiveTab("All_Seller")}
                className={
                  activeTab === "All_Seller"
                    ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                    : "text-gray-500 hover:text-[#FF0000]"
                }
              >
                All Seller
              </button>
            </div>
          </div>

          {/* Tab Content */}
          <div className="mt-6 ">
            {activeTab === "All_Buyer" && <All_Buyer />}
            {activeTab === "All_Seller" && <All_seller />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Product_Owner_details;
